(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hld-checklist-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.getElementById('hld-cpop');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    var dialog = root.querySelector('.hld-cpop__dialog');
    var html = document.documentElement;
    var mq = window.matchMedia('(max-width: 749px)');
    var lsGet = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
    var lsSet = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };
    var ssGet = function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
    var ssSet = function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} };
    var track = function (name, extra) {
      if (typeof window.hldTrack === 'function') window.hldTrack(name, Object.assign({ placement: 'popup' }, extra || {}));
    };

    var params = new URLSearchParams(location.search);
    var src = (params.get('utm_source') || '').toLowerCase();
    if (src.indexOf('omnisend') > -1) ssSet('hld-cpop-from-email', '1');

    var isOpen = false;
    var lockedByUs = false;
    var lastFocus = null;
    var success = !!root.querySelector('.hld-signup__success');
    var returnedFromSignup = success && location.hash === '#hld-pop-form';

    // The cookie-consent dimmer (layout/theme.liquid, z-index 9998) counts too: a
    // first-time visitor still deciding on cookies would otherwise get the popup
    // underneath it. Waiting for the choice also means the popup never competes
    // with the banner for the first thing they do on the site.
    function otherOverlayOpen() {
      return !!document.querySelector('.hld-drawer.is-open, .hld-navbar__menu.is-open, .hld-search.is-open, #hld-consent-dimmer.hld-visible');
    }
    function busyTyping() {
      var a = document.activeElement;
      return !!(a && a.closest && a.closest('form.hld-signup__form') && !root.contains(a));
    }

    function open(how) {
      if (isOpen) return;
      isOpen = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      if (success) {
        root.classList.add('is-success');
        var nothx = root.querySelector('.hld-cpop__nothx');
        if (nothx) nothx.textContent = 'Close';
      }
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
      if (!html.hasAttribute('scroll-lock')) { html.setAttribute('scroll-lock', ''); lockedByUs = true; }
      lsSet('hld-cpop-shown', String(Date.now()));
      if (!success) track('hld_checklist_view', { trigger: how });
      // Focus the dialog, never a field: a field focus would throw the keyboard
      // up on mobile, and the form counts any field focus as an "interaction" —
      // auto-focusing one would log every view as an interaction too.
      dialog.focus({ preventScroll: true });
    }

    function close(reason) {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      setTimeout(function () { if (!isOpen) root.hidden = true; }, 320);
      if (lockedByUs && !otherOverlayOpen()) html.removeAttribute('scroll-lock');
      lockedByUs = false;
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      if (!success) track('hld_checklist_close', { reason: reason || 'close' });
      if (returnedFromSignup && history.replaceState) {
        history.replaceState(null, '', location.pathname + location.search);
      }
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('[data-hld-cpop-close]');
      if (t) close(t.getAttribute('data-hld-cpop-close'));
    });
    document.addEventListener('keydown', function (e) {
      if (!isOpen) return;
      if (e.key === 'Escape') { close('escape'); return; }
      if (e.key !== 'Tab') return;
      // Keep Tab inside the dialog while it's open.
      var items = Array.prototype.filter.call(
        dialog.querySelectorAll('button, input, select, a[href]'),
        function (el) { return el.offsetParent !== null && !el.disabled; }
      );
      if (!items.length) return;
      var firstEl = items[0], lastEl = items[items.length - 1];
      if (e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
      else if (!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
    });

    // Straight back from submitting this popup: reopen on the success panel.
    if (returnedFromSignup) { open('signup_return'); return; }

    var force = params.get('hld_popup') === '1';
    if (!force) {
      if (root.dataset.subscribed === 'true') return;
      if (lsGet('hld-checklist-signup') === '1' || lsGet('hld-checklist-unlocked') === '1') return;
      if (ssGet('hld-cpop-from-email') === '1') return;
      var freqMs = (parseFloat(root.dataset.frequencyHours) || 24) * 3600 * 1000;
      var last = parseInt(lsGet('hld-cpop-shown') || '0', 10);
      if (last && Date.now() - last < freqMs) return;
    }

    var delay = force ? 1 : parseFloat(mq.matches ? root.dataset.delayMobile : root.dataset.delayDesktop);
    if (isNaN(delay)) delay = mq.matches ? 12 : 40;

    // Cookie choice still pending? The banner (CookieConsent, layout/theme.liquid) and its dimmer
    // load a moment AFTER the page, so checking the dimmer alone races: at 1s (the preview) the
    // popup opened, then the dimmer landed on top and hid it — "the link doesn't work", Alan,
    // 2 Oct 2026. validConsent() is the banner's own "a choice is on record" flag. If the banner
    // script never loads, give it 15s and then stop waiting on it.
    var startedAt = Date.now();
    function consentPending() {
      if (document.querySelector('#hld-consent-dimmer.hld-visible')) return true;
      var cc = window.CookieConsent;
      if (cc && typeof cc.validConsent === 'function') return !cc.validConsent();
      return Date.now() - startedAt < 15000;
    }

    function attempt() {
      // Applies to the ?hld_popup=1 preview too; it re-checks fast so the popup appears
      // right after the choice is made.
      if (consentPending()) {
        setTimeout(attempt, force ? 500 : 3000);
        return;
      }
      if (!force && (otherOverlayOpen() || html.hasAttribute('scroll-lock') || busyTyping())) {
        setTimeout(attempt, 3000);
        return;
      }
      // A signup through the band during the wait counts too.
      if (!force && lsGet('hld-checklist-signup') === '1') return;
      open(force ? 'preview' : 'timer');
    }
    setTimeout(attempt, delay * 1000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hld-freeship-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hld-freeship-bar')) {
    const PCT_KEY = 'hld-freeship-pct';
    const lastPct = (() => {
      try { return JSON.parse(sessionStorage.getItem(PCT_KEY)) || {}; } catch (e) { return {}; }
    })();
    const savePct = () => {
      try { sessionStorage.setItem(PCT_KEY, JSON.stringify(lastPct)); } catch (e) { /* private mode */ }
    };
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const liveRegion = () => {
      let el = document.getElementById('hld-freeship-live');
      if (!el && document.body) {
        el = document.createElement('div');
        el.id = 'hld-freeship-live';
        el.className = 'hld-freeship-sr';
        el.setAttribute('role', 'status');
        el.setAttribute('aria-live', 'polite');
        el.setAttribute('aria-atomic', 'true');
        document.body.appendChild(el);
      }
      return el;
    };
    if (document.body) liveRegion();
    else document.addEventListener('DOMContentLoaded', liveRegion);

    let booted = false;
    let lastMsg = '';
    const announce = (msg) => {
      const el = liveRegion();
      if (!el) return;
      el.textContent = '';
      setTimeout(() => { el.textContent = msg; }, 120);
    };

    class HldFreeshipBar extends HTMLElement {
      connectedCallback() {
        const msgEl = this.querySelector('.hld-freeship__msg');
        const msg = msgEl ? msgEl.textContent.replace(/\s+/g, ' ').trim() : '';
        if (booted && msg && msg !== lastMsg) announce(msg);
        if (msg) lastMsg = msg;

        const fill = this.querySelector('[data-hld-freeship-fill]');
        if (!fill) return;
        const ctx = this.dataset.context || 'page';
        const target = parseFloat(this.dataset.pct) || 0;
        const prev = ctx in lastPct ? lastPct[ctx] : 0;
        lastPct[ctx] = target;
        savePct();
        if (prev === target || reduceMotion()) return;

        const justQualified = this.hasAttribute('data-qualified') && prev < 100;
        fill.style.transition = 'none';
        fill.style.width = prev + '%';
        void fill.offsetWidth;

        const run = () => requestAnimationFrame(() => {
          fill.style.transition = '';
          fill.style.width = '';
          if (justQualified) this.classList.add('is-celebrating');
        });

        if (!('IntersectionObserver' in window)) { run(); return; }
        this._io = new IntersectionObserver((entries) => {
          if (!entries.some((e) => e.isIntersecting)) return;
          this._io.disconnect();
          run();
        });
        this._io.observe(this);
      }

      disconnectedCallback() {
        if (this._io) this._io.disconnect();
      }
    }

    customElements.define('hld-freeship-bar', HldFreeshipBar);
    booted = true;
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hld-signup-form"] && !Shopify.designMode) return;
  try {
    (function () {
    // --- Analytics -----------------------------------------------------------
    // One tiny helper, shared by every checklist surface (this snippet, the
    // footer band, the popup). Defined with `||` so whichever compiled script
    // runs first wins and they all push the same shape. Events go to:
    //   - window.dataLayer  → GTM container on the site → GA4
    //   - Shopify.analytics.publish → Customer events (custom pixel), if wired
    // `?hld_debug=1` echoes every event to the console for QA, and
    // window.__hldEvents keeps a copy either way.
    window.hldTrack = window.hldTrack || function (name, params) {
      params = Object.assign({}, params || {});
      (window.__hldEvents = window.__hldEvents || []).push(Object.assign({ event: name }, params));
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params)); } catch (e) {}
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish(name, params);
        }
      } catch (e) {}
      if (/[?&]hld_debug=1/.test(location.search)) console.log('[hldTrack]', name, params);
    };
    var placementOf = function (form) {
      var p = form && form.querySelector('[data-hld-placement]');
      return p ? p.getAttribute('data-hld-placement') : '';
    };
    // Signed-up memory. Read by the popup so a subscriber is never asked again,
    // and the checklist gate's own key is set too, so the "read it right now"
    // link on the success panel opens the full checklist rather than the gate.
    var rememberSignup = function () {
      try { localStorage.setItem('hld-checklist-signup', '1'); } catch (e) {}
      try { localStorage.setItem('hld-checklist-unlocked', '1'); } catch (e) {}
    };

    // --- One success message, on the form that was actually submitted ---
    //
    // Liquid's form.posted_successfully? is true for EVERY customer form on the
    // page once any one of them is posted, so the footer and the page card both
    // render the success state. Shopify redirects back with the submitted form's
    // id as the URL fragment (action="/contact#hld-nlp-form"), which is the only
    // thing that identifies the origin. Collapse the others.
    //
    // Surfaces marked [data-hld-success-shared] (the footer band) keep their
    // success panel even when another form was the one submitted: "You're in!"
    // is still true there, and hiding the band would leave a hole in the footer.
    var posted = document.querySelectorAll('form.hld-signup__form .hld-signup__success');
    var submittedId = (location.hash || '').replace('#', '');
    var submittedForm = null;
    if (posted.length) {
      var keptOne = false;
      posted.forEach(function (panel) {
        var form = panel.closest('form.hld-signup__form');
        if (!form) return;
        var isSubmitted = submittedId ? form.id === submittedId : !keptOne;
        if (isSubmitted) {
          keptOne = true;
          submittedForm = form;
          return;
        }
        if (posted.length < 2 || form.closest('[data-hld-success-shared]')) return;
        // Hide the whole card, not just the message — a bare empty card reads
        // as broken.
        var card = form.closest('.hld-card') || form;
        card.hidden = true;
      });
    }
    // A success panel only renders on the redirect straight after a real post.
    // No analytics event fires here: hld_checklist_submit already counts the
    // signup on the previous page (removed 2 Oct 2026 — same user interaction).
    if (submittedForm) {
      rememberSignup();
    }

    // Wires every signup form on the page independently, so the footer and an
    // in-page signup can coexist without sharing element ids or state.
    document.querySelectorAll('form.hld-signup__form').forEach(function (form) {
      if (form.dataset.hldSignupReady) return;
      form.dataset.hldSignupReady = '1';

      var step1 = form.querySelector('[data-hld-step="1"]');
      var step2 = form.querySelector('[data-hld-step="2"]');
      var nextBtn = form.querySelector('[data-hld-next]');
      var email = form.querySelector('[data-hld-email]');
      if (!step1 || !step2 || !nextBtn) return;

      // IMPORTANT — this form submits NATIVELY, never over fetch/XHR.
      //
      // Shopify's spam protection puts an hCaptcha token field in every
      // customer form, and only a real form submission gets that token
      // populated. Posting the FormData over fetch sends the token empty and
      // Shopify answers 400 "Missing CAPTCHA token" — so the signup is silently
      // lost. Worse, a fetch().then() runs on a 400 just as it does on a 200, so
      // an AJAX version cheerfully shows "You're in!" while capturing nobody.
      // That is exactly what this form did until 2026-07-27.
      //
      // navigator.sendBeacon has the same problem, so there is no abandonment
      // safety net here either — it could never pass the captcha.
      //
      // Native submit means the page reloads and Liquid's
      // `form.posted_successfully?` branch above renders the success panel.

      var placement = placementOf(form);
      var track = function (name) {
        if (placement) window.hldTrack(name, { placement: placement });
      };
      // "Interaction" = first focus on any field, Omnisend's own definition.
      form.addEventListener('focusin', function onFirst() {
        form.removeEventListener('focusin', onFirst);
        track('hld_checklist_interact');
      });

      function syncTags() {
        var tags = form.querySelector('[data-hld-tags]');
        var dd = form.querySelector('[data-hld-dob-dd]');
        var mm = form.querySelector('[data-hld-dob-mm]');
        var yyyy = form.querySelector('[data-hld-dob-yyyy]');
        if (!tags) return;
        // Keep every base tag (checklist-signup, src:…) and drop only a stale
        // dob: tag. This used to keep just the first tag, which would have
        // silently stripped the src: attribution tag on submit.
        var base = (tags.getAttribute('value') || 'checklist-signup')
          .split(',')
          .map(function (t) { return t.trim(); })
          .filter(function (t) { return t && t.indexOf('dob:') !== 0; })
          .join(', ');
        if (dd && mm && yyyy && dd.value && mm.value && yyyy.value) {
          tags.value = base + ', dob:' + yyyy.value + '-' + mm.value + '-' + dd.value;
        } else {
          tags.value = base;
        }
      }

      nextBtn.addEventListener('click', function () {
        if (email && !email.checkValidity()) {
          email.reportValidity();
          return;
        }
        if (window.omnisend && email && email.value) {
          try {
            window.omnisend.identifyContact({ email: email.value });
          } catch (e) {}
        }
        step1.hidden = true;
        step2.hidden = false;
        track('hld_checklist_step2');
        var firstField = step2.querySelector('select, input, button');
        if (firstField) firstField.focus();
      });

      // Write the dob: tag into the hidden field before the browser serialises
      // the form. Listeners run before serialisation, so no preventDefault is
      // needed — and none must be added, or the captcha token is lost again.
      form.addEventListener('submit', function () {
        syncTags();
        rememberSignup();
        track('hld_checklist_submit');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
